<template>
  <v-container fluid>
    <v-row class="mt-2 mx-2">
      <v-col xl="10">
        <v-row align="center">
          <v-col cols="12" md="4" lg="2">
            <v-select
              v-model="searchType"
              :items="searchTypes"
              :label="$t('generic.searchCritere')"
              outlined
              color="primary"
              success
              hide-details
              dense
              @change="resetItem()"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" lg="3">
            <v-autocomplete
              :items="items"
              :loading="isLoading"
              :search-input.sync="search"
              success
              outlined
              clearable
              hide-no-data
              hide-details
              hide-selected
              :item-text="crit"
              :label="$t('generic.Search')"
              :placeholder="$t('searchSubstance.searchInfo')"
              solo
              @keydown.enter="getResult(searchType, search)"
              return-object
              flat
              dense
            >
              <template v-slot:item="{ item }">
                <v-list-item-content @click="selectOneItem(item)">
                  <v-list-item-title
                    v-text="item.usual_name"
                    v-if="searchType === $t('generic.Name')"
                  ></v-list-item-title>
                  <v-list-item-title
                    v-text="item.ce"
                    v-if="searchType === 'N°CE'"
                  ></v-list-item-title>
                  <v-list-item-title
                    v-text="item.cas"
                    v-if="searchType === 'N°CAS'"
                  ></v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="12" lg="7">
            <v-row>
              <v-btn
                class="mx-4 my-2"
                depressed
                color="primary"
                :disabled="noResult || items.length === 0"
                @click="getResult(searchType, search)"
              >
                <v-icon class="mr-2"> mdi-magnify </v-icon>
                {{ $t("generic.Search") }}
              </v-btn>
              <v-btn
                class="mx-4 my-2"
                depressed
                color="secondary"
                :disabled="!substances.length"
                @click="exportResult"
              >
                {{ $t("searchSubstance.Export") }}
              </v-btn>
              <v-btn
                class="mx-4 my-2"
                depressed
                color="secondary"
                @click="openImport"
              >
                {{ $t("searchSubstance.Import") }}
              </v-btn>
              <!-- Pop Up D'import -->
              <v-dialog v-model="dialogImport" max-width="800px">
                <import-sub
                  v-on:closeImport="closeImport"
                  v-model="substancesImportedToSearch"
                  v-on:searchSub="searchSubImported()"
                  type="search"
                ></import-sub>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="displayTableResult">
          <v-col class="mx-0 px-0">
            <table-result
              :substances="substances"
              :headers="headers"
              :search="searchedValue"
            ></table-result>
          </v-col>
        </v-row>
        <v-row class="ml-1 mt-4 pt-4" v-else>
          <p v-if="noResult" class="text-subtitle-1">
            {{ $t("searchSubstance.noResult") }}
          </p>
          <p v-else class="text-subtitle-1">
            {{ $t("searchSubstance.info") }}
          </p>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableResult from "../components/TableResult.vue";
import ImportSub from "../components/ImportSub.vue";
import { mapGetters, mapMutations } from "vuex";
import { monitore } from "../components/helpers/helpers";

export default {
  data() {
    return {
      noResult: false, //true when demo
      displayTableResult: false,

      // autocomplete
      isLoading: false,
      items: [],
      search: null,
      searchedValue: "",

      //
      results: [],
      substances: [],
      headers: [],

      //Import
      dialogImport: false,
      substancesImportedToSearch: [],

      searchType: this.$t("generic.Name"),
    };
  },
  computed: {
    ...mapGetters(["currentPage", "lastPage"]),
    crit() {
      switch (this.searchType) {
        case this.$t("generic.Name"):
          return "usual_name";
        case "N°CE":
          return "ce";
        case "N°CAS":
          return "cas";
        default:
          return "cas";
      }
    },
    searchTypes() {
      return [this.$t("generic.Name"), "N°CE", "N°CAS"];
    },
  },
  watch: {
    search(val) {
      this.isLoading = false;
      this.items = [];
      // Si 2 caract
      if (val !== null && val.length > 1) {
        this.isLoading = true;
        this.resetSearch();
        this.searchSubstances(this.searchType, val);
      }
    },
    dialogImport(val) {
      val || this.closeImport();
    },
  },
  beforeMount() {
    if (this.lastPage.name === this.$route.name) {
      if (this.lastPage.params.headers) {
        this.displayTableResult = true;
        this.substances = this.lastPage.params.substances;
        this.headers = this.lastPage.params.headers;
        this.searchedValue = this.lastPage.params.searchedValue;
      }
    }
    if (this.currentPage.name === this.$route.name) {
      if (this.currentPage.params.headers) {
        this.displayTableResult = true;
        this.substances = this.currentPage.params.substances;
        this.headers = this.currentPage.params.headers;
        this.searchedValue = this.currentPage.params.searchedValue;
      }
    }
    this.setCurrentPage({
      name: this.$route.name,
      params: this.$route.params,
    });
  },
  components: {
    TableResult,
    ImportSub,
  },
  methods: {
    ...mapMutations(["setLastPage", "setCurrentPage", "resetCurrentPage"]),
    selectCrit(critere) {
      switch (critere) {
        case this.$t("generic.Name"):
          return "Nom";
        case "N°CE":
          return "ce";
        case "N°CAS":
          return "cas";
        default:
          return "Nom";
      }
    },
    // when type a letter in search bar
    async searchSubstances(critere, value) {
      this.isLoading = true;
      let url = "/substances";
      critere = this.selectCrit(critere);
      try {
        var response = await this.axios.get(url, {
          params: { critere: critere, value: value },
        });
        if (response.data.length) {
          this.items = response.data;
          this.isLoading = false;
        } else {
          this.noResult = true;
          this.isLoading = false;
        }
      } catch (err) {
        this.isLoading = false;
        this.noResult = true;
        console.log(err);
      }
    },

    // when clic on search
    // create a list of ID
    async getResult(critere, value) {
      monitore("Search substance", { critere: critere, value: value });
      if (this.items.length === 1) {
        this.setLastPage({
          name: this.$route.name,
          params: {},
        });
        this.$router.push({
          name: "ShowSubstances",
          params: { id: this.items[0]._id },
        });
      } else if (!this.noResult) {
        let itemForFetch = [];

        let subIDs = [];

        let url = "/substances";
        critere = this.selectCrit(critere);
        try {
          var response = await this.axios.get(url, {
            params: { critere: critere, value: value },
          });
          if (response.data.length) {
            itemForFetch = response.data;
            this.searchedValue = value;
            itemForFetch.forEach((substance) => {
              subIDs.push(substance._id);
            });

            this.search = null;
            this.items = [];
            this.noResult = false;
            if (subIDs.length) {
              this.fetchresult(subIDs);
              this.displayTableResult = true;
            } else {
              this.noResult = true;
            }
          } else {
            this.noResult = true;
          }
        } catch (err) {
          console.log(err);
        }
      }
    },

    // After fct Get RESULT, get data with good format for table result
    async fetchresult(subIDS) {
      try {
        let url = "/substances/nbbytheme";
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            liste: subIDS,
          },
        });
        if (response.status === 200) {
          if (response.data.length) {
            this.results = response.data;

            this.substances = [];
            this.headers = [
              {
                text: "Substance / Thématique",
                value: "substance",
                place: 1,
                sortable: false,
              },
            ];
            let tmpheaders = [];
            let place = 1;
            this.results.forEach((sub) => {
              let substance = {};
              sub.rulesbytheme.forEach((theme) => {
                if (tmpheaders.indexOf(theme.theme) < 0) {
                  place = place + 1;
                  tmpheaders.push(theme.theme);
                  this.headers.push({
                    text: theme.theme,
                    value: theme.theme,
                    align: "center",
                    sortable: false,
                    place: place,
                  });
                }
                let prop = theme.theme;
                substance[prop] = {
                  qte: theme.count,
                  texts: theme.rules,
                };
              });
              substance["substance"] = {
                name: sub.usual_name,
                ce: sub.ce,
                cas: sub.cas,
                id: sub._id,
                count: sub.totalRulesCount,
              };
              this.substances.push(substance);
            });
          }
          this.setCurrentPage({
            name: this.$route.name,
            params: {
              substances: this.substances,
              headers: this.headers,
              searchedValue: this.searchedValue,
            },
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    resetItem() {
      this.items = [];
    },
    resetSearch() {
      this.noResult = false; //true when demo
      this.displayTableResult = false;

      // autocomplete
      this.items = [];
      this.searchedValue = "";

      //
      this.results = [];
      this.substances = [];
      this.headers = [];
    },
    // ------------------
    // FONCTIONS D'IMPORT
    // ------------------
    openImport() {
      this.dialogImport = true;
    },
    closeImport() {
      this.dialogImport = false;
    },
    searchSubImported() {
      this.search = null;
      this.items = [];
      this.noResult = false;
      if (this.substancesImportedToSearch.length) {
        this.fetchresult(this.substancesImportedToSearch);
        this.displayTableResult = true;
      } else {
        // console.log("pas de résultats à chercher");
      }
      this.dialogImport = false;
    },
    async exportResult() {
      this.resetCurrentPage();
      try {
        let url = "/substances/nbbytheme";
        let subsID = this.substances.map((sub) => {
          return sub.substance.id;
        });
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            liste: subsID,
          },
        });
        if (response.status === 200) {
          if (response.data.length) {
            this.setLastPage({
              name: this.$route.name,
              params: {
                headers: this.headers,
                substances: this.substances,
                searchedValue: this.searchedValue,
              },
            });
            let substancesToExport = response.data.map((sub) => {
              // return sub;
              let substance = {
                substance: {
                  cas: sub.cas,
                  ce: sub.ce,
                  name: sub.usual_name,
                  id: sub._id,
                },
                rulesNames: [],
              };
              sub.rulesbytheme.forEach((theme) => {
                theme.rules.forEach((rule) => {
                  if (substance.rulesNames.indexOf(rule.name) < 0) {
                    substance.rulesNames.push(rule.name);
                  }
                });
              });
              return substance;
            });
            this.$router.push({
              name: "Export",
              params: { substances: substancesToExport },
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectOneItem(item) {
      this.setLastPage({
        name: this.$route.name,
        params: {},
      });
      this.$router.push({
        name: "ShowSubstances",
        params: { id: item._id },
      });
    },
  },
};
</script>
